import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectOfferId } from 'shared/selectors/offerData/offer/selectOfferId';

import { BookedOfferRecommendations } from '../../components/BookedOfferRecommendations';
import { selectBookedOfferRecommendations } from '../../selectors/bookedOfferRecommendations';

export const RecommendationsContainer: React.FC = () => {
  const recommendations = useSelector(selectBookedOfferRecommendations);
  const offerId = useSelector(selectOfferId);

  if (!recommendations || recommendations.length === 0) {
    return null;
  }

  return <BookedOfferRecommendations recommendations={recommendations} offerId={offerId} />;
};
